import { Mail, BarChart3, Palette, Users, MapPin, TrendingUp } from "lucide-react";

const plans = [
    {
        title: "Email campaign builder",
        description: "Design and send professional email promotions with custom templates to keep your audience engaged and informed.",
        icon: Mail,
    },
    {
        title: "Performance insights",
        description: "Monitor your website traffic, customer behavior, and campaign results with comprehensive analytics dashboards.",
        icon: BarChart3,
    },
    {
        title: "Visual content studio",
        description: "Build on-brand graphics and marketing materials with ready-to-use templates and design tools.",
        icon: Palette,
    },
    {
        title: "Lead generation tools",
        description: "Attract and capture potential customers with optimized landing pages and conversion-focused features.",
        icon: Users,
    },
    {
        title: "Directory listings",
        description: "Boost your online visibility by automatically submitting your business to major search directories and local listings.",
        icon: MapPin,
    },
    {
        title: "Search optimization",
        description: "Improve your search rankings with guided SEO recommendations and automated optimization for better discoverability.",
        icon: TrendingUp,
    }
];

export default function IncludedPlan() {
    return (
        <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8">
            <div className="container">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">
                        Included with Digital Marketing
                    </h2>
                    <p className="text-gray-300 md:text-lg max-w-2xl mx-auto">
                        Everything you need to grow your online presence and reach more customers
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {plans.map((plan, index) => {
                        const Icon = plan.icon;

                        return (
                            <div
                                key={index}
                                className="group bg-gray-800/30 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50 hover:border-blue-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1"
                            >
                                {/* Icon Box with gradient */}
                                <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-blue-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                                    <Icon size={28} className="text-white" />
                                </div>

                                {/* Content */}
                                <h3 className="text-white text-xl font-bold mb-3 group-hover:text-blue-400 transition-colors">
                                    {plan.title}
                                </h3>
                                <p className="text-gray-300 text-base leading-relaxed">
                                    {plan.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}